/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "./ListUsersSession.css";
import { LastAttemptAccess } from "../Dashboard";
import { Modal, Button } from "react-bootstrap";
import { KTSVG, toAbsoluteUrl } from "../../../../_metronic/helpers";
import { formatDbDateTimeShort } from "../../../utils/date";
import { useIntl } from "react-intl";

type Props = {
  lastAttemptsAccess: LastAttemptAccess[];
  inputVisible2: boolean;
};

const ListUsersLastAttemptsAccess: React.FC<Props> = ({
  lastAttemptsAccess,
  inputVisible2,
}) => {
  const pathUrl = "https://aacceson-image-bucket.s3.amazonaws.com/";
  const [modalPicture, setModalPicture] = useState(false);
  const intl = useIntl();
  const [selectedUserIndex, setSelectedUserIndex] = useState<number | null>(
    null
  );

  const openModalPicture = (index: number) => {
    setSelectedUserIndex(index);
    setModalPicture(true);
  };

  const closeModalPicture = () => {
    setModalPicture(false);
    setSelectedUserIndex(null);
  };

  const [filterName, setFilterName] = useState("");
  const [filterOption, setFilterOption] = useState("all");

  const handleFilterNameChange = (event: any) => {
    setFilterName(event.target.value);
  };

  const handleFilterOptionChange = (option: any) => {
    setFilterOption(option);
  };

  const filteredAttempts = lastAttemptsAccess.filter((attempt) => {
    const fullName = `${attempt?.user?.first_name} ${attempt?.user?.last_name}`;

    if (filterOption === "all") {
      return fullName.toLowerCase().includes(filterName.toLowerCase());
    } else if (filterOption === "entry") {
      return (
        fullName.toLowerCase().includes(filterName.toLowerCase()) &&
        attempt?.entrance?.description === "entry"
      );
    } else if (filterOption === "exit") {
      return (
        fullName.toLowerCase().includes(filterName.toLowerCase()) &&
        attempt?.entrance?.description !== "entry"
      );
    } else if (filterOption === "attempt") {
      return (
        fullName.toLowerCase().includes(filterName.toLowerCase()) &&
        !attempt?.access &&
        !attempt?.event_giveup
      );
    }
  });

  useEffect(() => {
    if (!inputVisible2) {
      setFilterName("");
    }
  }, [inputVisible2]);

  return (
    <>
      {inputVisible2 && (
        <>
          <div
            className={`fade-in p-2 ${
              inputVisible2 ? "active" : ""
            } w-100 d-flex flex-row justify-content-center align-items-center p-1`}
          >
            <span className="menu-icon me-3">
              <KTSVG
                path="/media/icons/duotune/general/gen004.svg"
                className="svg-icon-1 "
              />
            </span>
            <input
              type="text"
              className="search form-control form-control-solid w-100"
              placeholder="Filtrar por nome"
              value={filterName}
              onChange={handleFilterNameChange}
            />

            <button
              type="button"
              className="btn btn-sm me-1 btn-light-primary dropdown-toggle ms-3"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {filterOption === "all"
                ? "Todos"
                : filterOption === "entry"
                ? "Entrada"
                : filterOption === "exit"
                ? "Saída"
                : filterOption === "attempt"
                ? "Tentativa de Acesso"
                : ""}
            </button>
            <ul className="dropdown-menu">
              <li>
                <button
                  type="button"
                  className={`dropdown-item ${
                    filterOption === "all" ? "active" : ""
                  }`}
                  onClick={() => handleFilterOptionChange("all")}
                >
                  Todos
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={`dropdown-item ${
                    filterOption === "entry" ? "active" : ""
                  }`}
                  onClick={() => handleFilterOptionChange("entry")}
                >
                  Entrada
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={`dropdown-item ${
                    filterOption === "exit" ? "active" : ""
                  }`}
                  onClick={() => handleFilterOptionChange("exit")}
                >
                  Saída
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={`dropdown-item ${
                    filterOption === "attempt" ? "active" : ""
                  }`}
                  onClick={() => handleFilterOptionChange("attempt")}
                >
                  Tentativa de Acesso
                </button>
              </li>
            </ul>
          </div>
          <hr />
        </>
      )}

      {lastAttemptsAccess.length <= 0 ? (
        <p className="text-center">
          {" "}
          {intl.formatMessage({
            id: "DASHBOARD.NO_HISTORYC_INPUT",
          })}
        </p>
      ) : (
        filteredAttempts.map((lastAttempt, indexUser) => (
          <div className="container" key={indexUser}>
            <div className="row align-items-center bg-light-dark rounded mb-1 p-1">
              <div className="d-flex col align-items-center text-nowrap">
                <span
                  className="svg-icon svg-icon-warning me-5"
                  onClick={() => openModalPicture(indexUser)}
                >
                  <img
                    id="imgUsersBlack"
                    style={{
                      border: `3px solid ${lastAttempt?.user?.bracelets[0]?.bracelet_color?.color}`,
                      width: "3em",
                      height: "3em",
                      borderRadius: "3em",
                    }}
                    className="p-0 m-0"
                    alt="users"
                    src={`${
                      lastAttempt?.user?.profile_image
                        ? pathUrl + lastAttempt?.user?.profile_image
                        : "/media/avatars/blank.png"
                    }`}
                  />
                </span>
                <p
                  className={`fw-bold ${
                    !lastAttempt?.user?.compliance || lastAttempt?.user?.overdue
                      ? "text-danger text-hover-danger"
                      : "text-hover-primary"
                  } fs-6 m-0`}
                >
                  {lastAttempt?.user?.first_name} {lastAttempt?.user?.last_name}
                </p>
              </div>

              <div className="col text-end">
                <span className="fw-bold py-1 text-muted">
                  {formatDbDateTimeShort(lastAttempt?.created_at)}
                </span>
              </div>

              <div className="col fw-bold text-muted text-hover-dark m-0 fs-6 text-end">
                {lastAttempt?.origin_section?.description ?? "Fora do clube"}
              </div>

              <div className="col text-center">
                <i
                  style={{ fontSize: "25px" }}
                  className={`fa-solid fa-right-long ${
                    lastAttempt?.entrance?.description === "entry"
                      ? "text-success"
                      : "text-danger"
                  }`}
                ></i>
              </div>

              <div className="col fw-bold text-muted text-hover-dark m-0 fs-6 text-center">
                {lastAttempt?.destination_section?.description ??
                  "Fora do clube"}
              </div>

              <div className="col text-center">
                <span
                  className={`badge badge-${
                    lastAttempt?.access
                      ? lastAttempt?.entrance?.description === "entry"
                        ? "success"
                        : "danger"
                      : lastAttempt?.event_giveup
                      ? "danger"
                      : ""
                  }`}
                >
                  {lastAttempt?.access
                    ? lastAttempt?.entrance?.description === "entry"
                      ? "Entrou"
                      : "Saiu"
                    : lastAttempt?.event_giveup
                    ? lastAttempt?.entrance?.description === "entry"
                      ? "Desistiu de entrar"
                      : "Desistiu de sair"
                    : lastAttempt?.entrance?.description === "entry"
                    ? "Está tentando entrar..."
                    : "Está tentando sair..."}
                </span>
                {!lastAttempt?.event_giveup && !lastAttempt?.access && (
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                )}
              </div>
            </div>
          </div>
        ))
      )}
      <Modal onClose={closeModalPicture} show={modalPicture} centered={true}>
        <Modal.Body>
          {selectedUserIndex !== null ? (
            <div className="text-center">
              {lastAttemptsAccess[selectedUserIndex].user.profile_image !==
              null ? (
                <img
                  style={{
                    width: "300px",
                    height: "300px",
                    borderRadius: "8px",
                  }}
                  src={`${pathUrl}${lastAttemptsAccess[selectedUserIndex].user.profile_image}`}
                  alt={`Imagem de ${lastAttemptsAccess[selectedUserIndex].user.first_name} ${lastAttemptsAccess[selectedUserIndex].user.last_name}`}
                />
              ) : (
                <img
                  style={{
                    width: "300px",
                    height: "300px",
                    borderRadius: "8px",
                  }}
                  src={toAbsoluteUrl("/media/avatars/blank.png")}
                  alt=""
                />
              )}
            </div>
          ) : null}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeModalPicture}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export { ListUsersLastAttemptsAccess };
